import React from "react";
import { formatCurrency } from "../../helpers/utils";
import ActionButton from "./actionBtn";

export default function OrderInfo({ data }) {
  const isCompany = data?.ebarimtType === "COMPANY";
  const ebarimtText = isCompany ? "Байгууллага" : "Хувь хүн";
  const register = data?.ebarimtRegister;

  return (
    <ul className="list-unstyled mb-0">
      <li>
        <p className="mb-2">
          <span className="fw-bold me-2">Хаяг:</span>
          {data?.district?.name} {data?.address}
        </p>

        <p className="mb-2">
          <span className="fw-bold me-2">Утас:</span>
          {data?.phone}
        </p>

        <p className="mb-2">
          <span className="fw-bold me-2">Нийт дүн:</span>
          {formatCurrency(data?.totalAmount)}
        </p>

        <p className="mb-2">
          <span className="fw-bold me-2">Нийт тоо:</span>
          {data?.totalCount} ширхэг
        </p>

        {/* ✅ E-Barimt */}
        <p className="mb-4">
          <span className="fw-bold me-2">И-Баримт:</span>
          <span className="fw-bold">{ebarimtText}</span>
          {isCompany && register && (
            <span className="ms-2 text-muted">
              (Регистер: {register})
            </span>
          )}
        </p>

        <div className="d-flex gap-4">
</div>

      </li>
    </ul>
  );
}
